import { render } from "./PSeach.vue?vue&type=template&id=f076b6b4&scoped=true"
import script from "./PSeach.vue?vue&type=script&lang=js"
export * from "./PSeach.vue?vue&type=script&lang=js"

import "./PSeach.vue?vue&type=style&index=0&id=f076b6b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f076b6b4"]])

export default __exports__